/*
  *****************************************************
  My scan success page logic
  Page: /pages/scan-success
  ******************************************************
*/
const scanSuccessPageInit = async (id, flow) => {
  const {
    proxyUrl,
    vtoUtilsUrl
  } = window.assetUrls;

  try {

    const [utilsModule, proxyModule] = await Promise.all([
      import(vtoUtilsUrl),
      import(proxyUrl)
    ]);

    const { detectDeviceGroup } = utilsModule;
    const { getCustomerScan, getGuestScan } = proxyModule;

    const classes = {
      wrapper: ".my-scan",
      frame: ".my-scan__scan-frame",
      container: ".container-scan-success",
      loader: ".lds-my-scan-wrapper",
      loaderHidden: "lds-my-scan-wrapper--hidden"
    }

    const iframe = document.querySelector(classes.frame);
    const wrapper = document.querySelector(classes.wrapper);
    const container = document.querySelector(classes. container);

    let lastVersion = undefined;
    const isIos = detectDeviceGroup() === "group2";

    container.classList.remove('hidden');

    if(!iframe) return;

    if (isIos && wrapper) wrapper.classList.add("ios");

    // GTM on connection event
    const loginBtns = document.querySelectorAll(".vto-login-button");
    if (loginBtns) {
      loginBtns.forEach(clickable => {
        const button = clickable.querySelector('a, button') || clickable;
        button.addEventListener("click", () => {
          if (typeof gtm_ctaConnection === 'function') {
            gtm_ctaConnection();
          }
        });
      });
    }

    const loader = document.querySelector(classes.loader);
    let hasNoScan;
    let timeoutId;
    let data;

    const pollingFunction = async () => {

      if(flow === 'customer'){
          data = await getCustomerScan(id);
      } else {
          data = await getGuestScan(id);
      }
      if(data) {

        let route;
        let version;
        let status = data.status;

        route = data.route;
        version = data.version;

        const messages = document.querySelectorAll(".my-scan__in-progress-message");
        hasNoScan = data?.message != "" && data?.message != null;

        messages.forEach(message => {
          if(status == "INPROGRESS"){
            message.classList.add("my-scan__in-progress-message--active");
          }else{
            message.classList.remove("my-scan__in-progress-message--active");
          }
        })
        if((version !== lastVersion) || hasNoScan){
          lastVersion = version;
          
          loader.classList.add(classes.loaderHidden);

          if(route){
            const iframeLink = `${window.vto_widget_url}/${route}?hint=false&slideFull=true`; 
      
            iframe.setAttribute("src", iframeLink);
      
            if(timeoutId) {
              clearTimeout(timeoutId);
            }
          }
        }
      }
    }

    pollingFunction();
  } catch (error) {
    console.error("Failed to initialize Scan Success page:", error);
  }
}


async function updateGuestScanFromQuery() {
      const {
    proxyUrl,
    vtoUtilsUrl
  } = window.assetUrls;


    const [utilsModule, proxyModule] = await Promise.all([
      import(vtoUtilsUrl),
      import(proxyUrl)
    ]);

  const { updateStorage } = utilsModule;
  const { verifyGuestScan } = proxyModule;
  const customerId = window['customerInfo']['id'];

  const buttonFromUser = document.querySelector('.from_login');
  const buttonFromGuest = document.querySelector('.guest_user');

  if(customerId){
    scanSuccessPageInit(customerId, 'customer');
  } else {
      const guestScanKey = 'guest_scan'; // Key for session storage

        // Parse URL parameters
        const urlParams = new URLSearchParams(window.location.search);
        const newGuestId = urlParams.get('guestId');
       

        if(newGuestId) {
          buttonFromGuest.classList.remove('hidden');
          const { guestId, status, expiration } = await verifyGuestScan(newGuestId);
          if (guestId && status !== 'NOSCAN') {
              updateStorage (guestScanKey, { id: guestId, has_scan: true, expiration })
              scanSuccessPageInit(guestId, 'guest');
          } else {
              updateStorage (guestScanKey, { id: newGuestId, has_scan: false })
          }
        } else {
          buttonFromUser.classList.remove('hidden');
        }


  }
}

// Call the function on page load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    updateGuestScanFromQuery().catch(error => {
      console.error('Error updating guest scan:', error);
    });
  });
} else {
  // DOM already loaded
  console.log('Document already loaded, updating guest scan...');
  updateGuestScanFromQuery().catch(error => {
    console.error('Error updating guest scan:', error);
  });
}